import { FlexConditionTarget } from '@/data/data-models';
import { triggerNames } from '@/data/events/triggers';

export const conditionTargetNames = {
    COOKIE: 'cookie',
    FORM: 'form',
    FORM_FIELD: 'formField',
    FORM_RESPONSE: 'formResponse',
    COLLECTION: 'collectionLoad',
};

export default new Map([
    [conditionTargetNames.COOKIE, new FlexConditionTarget({
        name: conditionTargetNames.COOKIE,
        label: 'cookie',
        component: 'condition-target-cookie',
        triggers: [],
    })],

    [conditionTargetNames.FORM, new FlexConditionTarget({
        name: conditionTargetNames.FORM,
        label: 'form',
        component: 'condition-target-form',
        triggers: [],
    })],

    [conditionTargetNames.FORM_FIELD, new FlexConditionTarget({
        name: conditionTargetNames.FORM_FIELD,
        label: 'form field',
        component: 'condition-target-form',
        triggers: [],
    })],

    [conditionTargetNames.FORM_RESPONSE, new FlexConditionTarget({
        name: conditionTargetNames.FORM_RESPONSE,
        label: 'form response data',
        component: 'condition-target-form-response',
        triggers: [triggerNames.SUBMIT],
    })],

    [conditionTargetNames.COLLECTION, new FlexConditionTarget({
        name: conditionTargetNames.COLLECTION,
        label: 'collection',
        component: 'condition-collection-data',
        triggers: [],
    })],
]);
